import styled from "styled-components";

export const ActionsContainer = styled.div`
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: inline-flex;
  border-top: 1px solid rgb(233, 233, 233);
`;

export const DeleteButton = styled.button`
  width: 65px;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  outline: 2px #e0a3a3 solid;
  outline-offset: -2px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: flex;
  background: none;
  border: none;
  cursor: pointer;
  &:focus,
  &:active {
    outline: 2px #e0a3a3 solid;
    outline-offset: -2px;
  }
`;

export const EditButton = styled.button`
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  outline: 2px #3f7f7d solid;
  outline-offset: -2px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: flex;
  background: none;
  border: none;
  cursor: pointer;
  &:focus,
  &:active {
    outline: 2px #3f7f7d solid;
    outline-offset: -2px;
  }
`;

export const DeleteIconContainer = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
`;

export const EditIconContainer = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
`;
